import Vue from 'vue'

export default {
	state: {
		spots: [],
		allSpots: []
	},
	mutations: {
		loadAllSpots (state, payload) {
			state.allSpots = payload
		},
		loadSpots (state, payload) {
			state.spots = payload
		},
		addSpot (state, payload) { 
			const index = state.spots.length
			Vue.set(state.spots, index, payload)  
		},
		changeSpot (state, payload) {
			const spot = state.spots.find(s => s.id === payload.id)
			Vue.set(state.spots, state.spots.indexOf(spot), payload)  
		},
		deleteSpot (state, payload) {
			state.spots = state.spots.filter(spot => spot.id !== payload) 
		}
	},
	actions: {
		async fetchAllSpots ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []
			
			let gameId = 'game' + payload.gameId
			let round = 'round' + payload.round
			
			try {
				const spots = await Vue.$db.collection(gameId).doc(round).collection('spots')

				.get()

				if (spots) {
					spots.forEach(doc => {
						const spot = doc.data()

						const sp = {
							id: doc.id,
							company: spot.company,
							type: spot.type,
							name: spot.name,
							coreFeature: spot.coreFeature,
							advancedFeature: spot.advancedFeature,
							price: spot.price,
							value: spot.value,
							channels: spot.channels,
							investments: spot.investments
						}

						if (spot.trademark) {
							sp.trademark = spot.trademark
						}
						resArr.push(sp)
					})
					commit('loadAllSpots', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchSpots ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []
			
			let gameId = 'game' 
			let round = 'round'
			let company = ''

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
				company = payload.company
			}
			else {
				gameId+= getters.gameId
				round+= getters.currentRound
				company = getters.company
			}

			try {
				const spots = await Vue.$db.collection(gameId).doc(round).collection('spots')
				.where("company", "==", company)
				.get()

				if (spots) {
					spots.forEach(doc => {
						const spot = doc.data()

						const sp = {
							id: doc.id,
							type: spot.type,
							name: spot.name,
							coreFeature: spot.coreFeature,
							advancedFeature: spot.advancedFeature,
							price: spot.price,
							value: spot.value,
							channels: spot.channels,
							investments: spot.investments
						}

						if (spot.trademark) {
							sp.trademark = spot.trademark
						}
						resArr.push(sp)
					})
					commit('loadSpots', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addSpot ({commit, getters}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			
			let id = payload.spot.id
			
			if (!id) {
				id = `${payload.spot.company}-${payload.spot.name}`
			}
			else {
				delete payload.spot.id
			}
			
			try {
				const spotRef = await Vue.$db.collection(gameId).doc(round).collection('spots')
				.doc(id)
				.set(payload.spot)
				
				payload.spot.id = id
				
				commit('setLoading', false)
				commit('addSpot', payload.spot)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async changeSpot ({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.spot.id

			delete payload.spot.id

			try {
				await Vue.$db.collection(gameId).doc(round).collection('spots').doc(id)
				.set(payload.spot)

				payload.spot.id = id

				commit('setLoading', false)
				commit('changeSpot', payload.spot)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async deleteSpot ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('spots').doc(id).delete()

				commit('setLoading', false)
				commit('deleteSpot', id)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}
	},
	getters: {
		spots (state) {
			return state.spots
		},
		allSpots (state) {
			return state.allSpots
		},
		companySpots (state) {
			return state.spots.filter(spot => spot.type === 0)
		},
		brandSpots (state) {
			return state.spots.filter(spot => spot.type === 1)
		}
		
	}
}